module.exports = __webpack_public_path__ + "img/38.3aba1cf7.jpg";